/**
 * Created by idea on 03/07/2017.
 */
import {Component, Injector, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms'
import {ProductService} from '../services/Product.service';

declare var $:any;

@Component({
    selector: 'hp-variant-history',
    templateUrl: 'variant-history.template.html',
})

export class VariantHistoryComponent implements OnInit {
    model = {};
    public message :{content:string,class:string} = null;
    public detail : any;
    public variants : any;

    constructor(
                private injector: Injector,
                private product:ProductService,
                private _fb:FormBuilder) {

    }

    ngOnInit() {
        this.detail = this.injector.get('product');
        this.variants = this.injector.get('variants');
    }




}


// WEBPACK FOOTER //
// /app/src/app/common/helper/variant-history.component.ts